import { useMutation } from 'react-query';
import { authFetch } from '../../../../CommonUtils/authFetch';
import { queryClient } from '../../../../../config/queryClient';
import { queryKeys } from './queryKeys';
import { AssetBucketingDTO } from './useAssetBucketQuery';

const resetAssetBuckets = (): Promise<AssetBucketingDTO> => {
  return authFetch('/Adviser/AssetBucketing/Default', {
    method: 'POST',
  });
};

export const useResetAssetBucketsMutation = () => {
  return useMutation(resetAssetBuckets, {
    onSuccess: assetBuckets => {
      queryClient.setQueryData(queryKeys.assetBucket(), assetBuckets);
    },
  });
};
